import {EnumOrganisationType} from "../../app/DTO/Organisation/OrganisationDTO";

export class OrganisationAccountDTO{
  public id:number;
  public name:string;
  public type:EnumOrganisationType;
  public isSelectedAccount:boolean;
  constructor() {
  }

  bindData(obj: any): void {
    if (obj == null) {
      return;
    }

    if (obj.id) {
      this.id = obj.id;
    }

    if (obj.name) {
      this.name = obj.name;
    }

    if (obj.type) {
      this.type = obj.type;
    }
    if(obj.isSelectedAccount){
      this.isSelectedAccount=obj.isSelectedAccount;
    }
  }
}
